/* eslint-disable eslint-comments/disable-enable-pair -- remove warning */
/* eslint-disable complexity -- remove warning */
/* eslint-disable no-unsafe-optional-chaining -- needed */
/* eslint-disable dot-notation -- needed */
/* eslint-disable no-unused-vars -- needed */
/* eslint-disable arrow-parens -- needed */
/* eslint-disable no-shadow -- needed */
/* eslint-disable unicorn/better-regex -- needed */
/* eslint-disable no-fallthrough -- needed */
import React, { useCallback, useEffect, useState } from 'react';
import {
  Button, Checkbox,
  SelectNative,
  SelectNativeOption,
  Heading,
  ComponentLevelNotification,
} from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import CardMemberInfo from '../../CardMemberInfo';
import { Layout } from '../layout';
import { renderHTML } from '../../../../../utilities/render-html';
import useOneData from '../../../../../hooks/useOneData';
import useDisableButton from '../../../../../hooks/useDisableButton';
import {
  getEndpoint,
  getEnrollmentRequestBody,
} from '../../../../../api/api-utils';
import {
  CreateLoyaltyBenefitEnrollmentStatusVx,
  suppressCheckboxForLocaleList,
} from '../../../../../constants';
import { FormField } from './membership-input-international-form-field';

export function MembershipInputInternationalApply(props) {
  const fields = {
    firstName: '',
    lastName: '',
    nameTitle: '',
    street1: '',
    street2: '',
    street3: '',
    city: '',
    country: '',
    dob: '',
    email: '',
    state: '',
    passport: '',
    postal: '',
    phoneNumber: '',
    phoneCountry: '',
    account: '',
  };
  const name = props?.requiredFields?.name;
  const address = props?.requiredFields?.address;
  const email = props?.requiredFields?.email;
  const account = props?.requiredFields?.account;
  const phone = props?.requiredFields?.phone;
  const dob = props?.requiredFields?.dob;
  const passport = props?.requiredFields?.passport;

  const [checkbox, toggleCheckBox] = useState(false);
  const [validateAll, setValidateAll] = useState(fields);
  const [inputWarning, setInputWarning] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [errors, setErrors] = useState(fields);
  const [nameValue, setNameValue] = useState({
    firstName: name?.firstName?.value ? name?.firstName?.value : undefined,
    lastName: name?.lastName?.value ? name?.lastName?.value : undefined,
    nameTitle: name?.nameTitle?.value ? name?.nameTitle?.value : undefined,
  });
  const [addressValue, setAddressValue] = useState({
    street1: address?.street1?.value ? address?.street1?.value : undefined,
    street2: address?.street2?.value ? address?.street2?.value : undefined,
    street3: address?.street3?.value ? address?.street3?.value : undefined,
    city: address?.city?.value ? address?.city?.value : undefined,
    state: address?.state?.value ? address?.state?.value : undefined,
    postal: address?.postal?.value ? address?.postal?.value : undefined,
    country: address?.country?.value ? address?.country?.value : undefined,
  });
  const [emailValue, setEmailValue] = useState(
    email?.emailAddress?.value || undefined
  );
  const [dobValue, setDobValue] = useState(dob?.value || undefined);
  const [accountValue, setAccountValue] = useState(
    account?.memberAccount?.value || undefined
  );
  const [passportValue, setPassportValue] = useState(
    passport?.value || undefined
  );
  const [phoneNumberValue, setPhoneNumberValue] = useState(
    phone?.phoneNumber?.value || undefined
  );
  const [phoneCountryValue, setPhoneCountryValue] = useState(
    phone?.phoneCountry?.value || undefined
  );
  const [agreeError, setAgreeError] = useState(false);
  const [isValid, setIsValid] = useState({
    firstName: name?.firstName?.must === true && fields?.firstName,
    lastName: name?.lastName?.must === true && fields?.lastName,
    nameTitle: name?.nameTitle?.must === true && fields?.nameTitle,
    street1: address?.street1?.must === true && fields?.street1,
    street2: address?.street2?.must === true && fields?.street2,
    street3: address?.street3?.must === true && fields?.street3,
    city: address?.city?.must === true && fields?.city,
    company: address?.company?.must === true && fields?.company,
    country: address?.country?.must === true && fields?.country,
    dob: dob?.dateOfBirth?.must === true && fields?.dob,
    email: email?.emailAddress?.must === true && fields?.email,
    state: address?.state?.must === true && fields?.state,
    passport: passport?.fullName?.must === true && fields?.passport,
    postal: address?.postal?.must === true && fields?.postal,
    account: account?.memberAccount?.must === true && fields?.account,
    phoneNumber: phone?.phoneNumber?.must === true && fields?.phoneNumber,
    phoneCountry: phone?.phoneCountry?.must === true && fields?.phoneCountry,
  });

  const intl = useIntl(); // Hook for accessing locale content, intl.formatMessage()
  const stepTransition = props.stepTransition;
  const selectedProduct = props.selectedProduct;
  const label = props.callToAction?.INTERNAL.label || props.callToAction?.ANCHOR?.label || 'Enroll Now';
  const languageData = props?.languageData;
  const description = props?.description;
  const { isFetching, error, data } = props?.cardData;
  const safeDescription = renderHTML(description);
  const faasApiUrl = props?.faasApiUrl;
  const sorBenefitId = props.sorBenefitId;
  const benefitName = props.benefitName;
  const cardname = props.cardname;
  const benefitTitle = props?.benefitTitle;
  const endpoint = getEndpoint(
    faasApiUrl,
    CreateLoyaltyBenefitEnrollmentStatusVx
  );
  const memberAccount = account?.show ? accountValue?.account : null;
  const memberAddress1 = address?.show ? addressValue?.street1 : null;
  const memberAddress2 = address?.show ? addressValue?.street2 : null;
  const memberAddress3 = address?.show ? addressValue?.street3 : null;
  const memberCity = address?.show ? addressValue?.city : null;
  const memberCountry = address?.show ? addressValue?.country : null;
  const memberDOB = dob?.show ? dobValue?.dob : null;
  const memberEmail = email?.show ? emailValue?.email : null;
  const memberPassport = passport?.show ? passportValue?.passport : null;
  const memberPhoneNumber = phone && phone?.show ? phoneNumberValue?.phoneNumber : null;
  const memberPhoneCountry = phone && phone?.show ? phoneCountryValue?.phoneCountry : null; // check if phoneCountry is required
  const memberPostalCode = address?.show ? addressValue?.postal : null;
  const memberState = address?.show ? addressValue?.state : null;
  const memberFirstName = name?.show ? nameValue?.firstName : null;
  const memberLastName = name?.show ? nameValue?.lastName : null;
  const memberNameTitle = name?.show ? nameValue?.nameTitle : null;
  const requestOptions = {
    benefitName,
    cardname,
    membershipNumber: memberAccount,
    memberAddress1,
    memberAddress2,
    memberAddress3,
    memberCity,
    memberCountry,
    memberDOB,
    memberEmail,
    memberPassport,
    memberPhoneNumber,
    memberPhoneCountry,
    memberPostalCode,
    memberState,
    memberFirstName,
    memberLastName,
    memberNameTitle,
  };
  const requestOptionsFilter = Object.keys(requestOptions).reduce(
    (acc, key) => {
      if (requestOptions[key]) {
        acc[key] = requestOptions[key];
      }
      return acc;
    },
    {}
  );
  const locale = props?.locale;
  const shouldSuppressCheckbox = suppressCheckboxForLocaleList.includes(locale);
  const requestBody = getEnrollmentRequestBody(
    selectedProduct,
    sorBenefitId,
    locale,
    requestOptionsFilter
  );
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;
  const endpointOptions = {
    body: requestBody,
    defer: true, // defers fetchye call until run function is invoked
  };
  const { isLoading, run } = useOneData(endpoint, endpointOptions);
  const { isDisabledAfterSubmit, disableButton } = useDisableButton();
  // create a new object of initial field values
  const initialFields = {
    name: {
      firstName: nameValue.firstName,
      lastName: nameValue.lastName,
      nameTitle: nameValue.nameTitle,
    },
    address: {
      street1: addressValue.street1,
      street2: addressValue.street2,
      street3: addressValue.street3,
      city: addressValue.city,
      state: addressValue.state,
      postal: addressValue.postal,
      country: addressValue.country,
    },
    email: emailValue,
    dob: dobValue,
    account: accountValue,
    passport: passportValue,
    phone: {
      phoneNumber: phoneNumberValue,
      phoneCountry: phoneCountryValue,
    },
  };

  // phoneCountry dropdown logic
  const phoneCountryLabel = phone?.phoneCountry?.label;
  const phoneMapList = phone?.phoneCountry?.phoneMap || [];
  const defaultLabel = {
    value: '',
    label: phoneCountryLabel,
  };
  const modifiedPhoneMapList = Object.entries(phoneMapList).map(
    ([key, value]) => ({ [value]: key })
  );
  const formatPhoneCountrySelection = modifiedPhoneMapList?.map((obj) => {
    const key = Object.keys(obj)[0];
    const keyNumber = Number.parseInt(key, 10);
    const val = obj[key];
    return {
      value: keyNumber,
      label: val,
    };
  });

  const formattedSelections = () => {
    const formatSelections = formatPhoneCountrySelection?.map((selection) => {
      const value = selection?.value;
      const label = selection?.label;
      const hasSelection = value && label;
      if (hasSelection) {
        return { value, label };
      }
      return null;
    });
    formatSelections.unshift(defaultLabel);
    return formatSelections;
  };

  // map through required fields and return new object of key value pairs when show and must both equal true
  const requiredFields = Object.keys(props.requiredFields)
    .map((key) => {
      const fieldGroup = props.requiredFields[key];

      // Check if the field group is required to be shown
      if (!fieldGroup.show) {
        return null;
      }

      // Check if any nested fields have must: true
      const hasRequiredFields = Object.values(fieldGroup).some(
        (field) => field.must === true
      );

      // Return the field group if it has required fields
      return hasRequiredFields ? { [key]: initialFields[key] } : null;
    })
    .filter(Boolean); // Remove null values

  // create new object with key value pairs from requiredFields array
  const requiredFieldsObject = Object.assign({}, ...requiredFields);

  // map through requireFieldsObject and flatten out nested objects
  const flattenedRequiredFields = Object.keys(requiredFieldsObject).reduce(
    (acc, key) => {
      if (typeof requiredFieldsObject[key] === 'object') {
        return { ...acc, ...requiredFieldsObject[key] };
      }
      return { ...acc, [key]: requiredFieldsObject[key] };
    },
    {}
  );

  // check to see if a required input field is empty
  const isRequiredFieldEmpty = !!Object.values(flattenedRequiredFields).some(value => value === '' || value === undefined);

  const checkDisabled = useCallback(async (fieldErrors, checkbox) => {
    // Wait for fieldErrors and isCheckboxChecked to be defined
    if (fieldErrors === undefined || checkbox === undefined) {
      return; // Exit early if either fieldErrors or isCheckboxChecked is undefined
    }
    // Check if any validation errors exist or if checkbox is unchecked
    const hasErrors = fieldErrors
      ? Object.values(fieldErrors).some((error) => error.length > 0)
      : false;
    const isSubmitDisabled = hasErrors || isRequiredFieldEmpty || (!shouldSuppressCheckbox && !checkbox);
    setIsDisabled(isSubmitDisabled);
  }, [isRequiredFieldEmpty]);

  useEffect(() => {
    checkDisabled(errors, checkbox);
  }, [isRequiredFieldEmpty, checkDisabled, checkbox, errors]);

  useEffect(() => {
    checkDisabled(errors, checkbox);
  }, [isRequiredFieldEmpty, checkDisabled, checkbox, errors]);

  const checkLength = (value, min, max) => {
    return value?.length > min && value?.length < max;
  };

  const validate = (e, field) => {
    const value = e.target.value;
    const valid = checkLength(value, field?.minLength, field?.maxLength);
    let isValidField = true;
    let fieldErrors = { ...errors };
    const isAlphabetOnly = /^[A-Za-z]+$/;
    const isNumberOnly = /^[0-9]+$/;
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isAlphaNumeric = /^[A-Za-z0-9]*$/;
    // TODO: Temporary solution for error messages.
    // Replace with error messages from BCAT/BCM when available.
    const isFrCA = locale === 'fr-CA'
      ? `Il doit y avoir de ${field.minLength} à ${field.maxLength} caractères dans le champ.`
      : `Field must be between ${field.minLength} and ${field.maxLength} characters.`;
    switch (e.target.name) {
      case 'firstName':
      case 'lastName':
      case 'nameTitle':
      case 'city':
      case 'country':
      case 'state':
        if (!isAlphabetOnly.test(value)) {
          setIsValid({ ...isValid, [e.target.name]: false });
          fieldErrors[e.target.name] = locale === 'fr-CA' ? 'Seuls les caractères alphabétiques sont acceptés.' : 'Only alphabets are allowed';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, [e.target.name]: true });
          fieldErrors[e.target.name] = '';
        }
        break;
      case 'street1':
      case 'street2':
      case 'street3':
        if (value?.trim() === '') {
          setIsValid({ ...isValid, [e.target.name]: false });
          fieldErrors[e.target.name] = locale === 'fr-CA' ? 'Veuillez entrer une adresse valide' : 'Please enter a valid address';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, [e.target.name]: true });
          fieldErrors[e.target.name] = '';
        }
        break;
      case 'passport':
      case 'postal':
        if (!isNumberOnly.test(value)) {
          setIsValid({ ...isValid, [e.target.name]: false });
          fieldErrors[e.target.name] = locale === 'fr-CA' ? 'Seuls les chiffres sont acceptés' : 'Only numbers are allowed';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, [e.target.name]: true });
          fieldErrors[e.target.name] = '';
        }
        break;
      case 'dob':
        if (!isAlphaNumeric.test(value)) {
          setIsValid({ ...isValid, [e.target.name]: false });
          fieldErrors[e.target.name] = locale === 'fr-CA' ? 'Seuls les caractères alphanumériques sont acceptés' : 'Only alphanumeric characters are allowed';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, [e.target.name]: true });
          fieldErrors[e.target.name] = '';
        }
        break;
      case 'email':
        if (!isValidEmail.test(value)) {
          setIsValid({ ...isValid, [e.target.name]: false });
          fieldErrors[e.target.name] = locale === 'fr-CA' ? 'Entrez une adresse de courriel valide' : 'Enter a valid email';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, [e.target.name]: true });
          fieldErrors[e.target.name] = '';
        }
        break;
      case 'phoneNumber':
        if (field?.type === 'number') {
          if (value.length < field?.minLength) {
            setIsValid({ ...isValid, phoneNumber: false });
            fieldErrors['phoneNumber'] = locale === 'fr-CA' ? `Il doit y avoir au moins ${field.minLength} caractères dans le champ.` : `Field must have at least ${field.minLength} characters.`;
            isValidField = false;
          } else if (value.length > field?.maxLength) {
            setIsValid({ ...isValid, phoneNumber: false });
            fieldErrors['phoneNumber'] = locale === 'fr-CA' ? `Il doit y avoir de ${field.minLength} à ${field.maxLength} caractères dans le champ.` : `Field must be between ${field.minLength} and ${field.maxLength} characters.`;
            isValidField = false;
          } else if (
            value.length >= field?.minLength
            && value.length <= field.maxLength
          ) {
            setIsValid({ ...isValid, phoneNumber: true });
            fieldErrors['phoneNumber'] = '';
          } else {
            setIsValid({ ...isValid, phoneNumber: false });
            fieldErrors['phoneNumber'] = locale === 'fr-CA' ? 'Entrée invalide' : 'Invalid input';
          }
          break;
        }
      case 'phoneCountry':
        if (value?.trim() === '') {
          setIsValid({ ...isValid, phoneCountry: false });
          fieldErrors['phoneCountry'] = locale === 'fr-CA' ? 'Veuillez sélectionner un pays' : 'Please select a country';
          isValidField = false;
        } else {
          setIsValid({ ...isValid, phoneCountry: true });
          fieldErrors['phoneCountry'] = '';
        }
        break;
      case 'account':
        if (field?.must === true) {
          if (field?.type === 'number') {
            if (value.length < field?.minLength) {
              setIsValid({ ...isValid, account: false });
              fieldErrors['account'] = locale === 'fr-CA' ? `Il doit y avoir  ${field.minLength} caractères.` : `Field must have ${field.minLength} characters.`;
              isValidField = false;
            } else if (value.length > field?.maxLength) {
              setIsValid({ ...isValid, account: false });
              fieldErrors['account'] = locale === 'fr-CA' ? `Il doit y avoir de ${field.minLength} à ${field.maxLength} caractères dans le champ.` : `Field must be between ${field.minLength} and ${field.maxLength} characters.`;
              isValidField = false;
            } else if (
              value.length >= field?.minLength
              && value.length <= field.maxLength
            ) {
              setIsValid({ ...isValid, account: true });
              fieldErrors['account'] = '';
            } else {
              setIsValid({ ...isValid, account: false });
              fieldErrors['account'] = locale === 'fr-CA' ? 'Entrée invalide' : 'Invalid input';
              isValidField = false;
            }
            break;
          }
          if (!isAlphaNumeric.test(value)) {
            setIsValid({ ...isValid, account: false });
            fieldErrors['account'] = locale === 'fr-CA' ? 'Seuls les caractères alphanumériques sont acceptés' : 'Only alphanumeric characters are allowed';
            isValidField = false;
          } else if (value.length < field?.minLength) {
            setIsValid({ ...isValid, account: false });
            fieldErrors['account'] = locale === 'fr-CA' ? `Il doit y avoir  ${field.minLength} caractères.` : `Field must have ${field.minLength} characters.`;
            isValidField = false;
          } else if (value.length > field?.maxLength) {
            setIsValid({ ...isValid, account: false });
            fieldErrors['account'] = locale === 'fr-CA' ? `Il doit y avoir de ${field.minLength} à ${field.maxLength} caractères dans le champ.` : `Field must be between ${field.minLength} and ${field.maxLength} characters.`;
            isValidField = false;
          } else {
            setIsValid({ ...isValid, account: true });
            fieldErrors['account'] = '';
          }
        }
        break;
      default:
        setIsValid({ ...isValid, [e.target.name]: valid });
        fieldErrors[e.target.name] = valid
          ? ''
          : isFrCA;
        break;
    }
    // Update error state
    setErrors(fieldErrors);
    // Recheck if the submit button should be disabled
    checkDisabled(fieldErrors, checkbox, {
      ...isValid,
      [e.target.name]: isValidField,
    });
  };
  // eslint-disable-next-line consistent-return -- needed
  const submit = async () => {
    const isValidSubmit = checkbox;
    const showAgreeError = !checkbox;
    if (showAgreeError && !shouldSuppressCheckbox) {
      return setAgreeError(true);
    }
    if (shouldSuppressCheckbox || isValidSubmit) {
      setAgreeError(false);
      disableButton();
      const { data: enrollmentSuccess, error: enrollmentError } = await run();
      if (enrollmentSuccess) {
        stepTransition(true, false);
      }
      if (enrollmentError) {
        stepTransition(false, true);
      }
    }
  };
  /* eslint-enable complexity -- needed */
  const onChangeInput = (e, field) => {
    validate(e, field);
    setValidateAll({
      ...validateAll,
      [e.target.name]: e.target.value,
    });
    switch (e.target.name) {
      case 'firstName':
        setNameValue({ ...nameValue, firstName: e.target.value });
        break;
      case 'lastName':
        setNameValue({ ...nameValue, lastName: e.target.value });
        break;
      case 'nameTitle':
        setNameValue({ ...nameValue, nameTitle: e.target.value });
        break;
      case 'street1':
        setAddressValue({ ...addressValue, street1: e.target.value });
        break;
      case 'street2':
        setAddressValue({ ...addressValue, street2: e.target.value });
        break;
      case 'street3':
        setAddressValue({ ...addressValue, street3: e.target.value });
        break;
      case 'city':
        setAddressValue({ ...addressValue, city: e.target.value });
        break;
      case 'state':
        setAddressValue({ ...addressValue, state: e.target.value });
        break;
      case 'postal':
        setAddressValue({ ...addressValue, postal: e.target.value });
        break;
      case 'country':
        setAddressValue({ ...addressValue, country: e.target.value });
      case 'email':
        setEmailValue({ ...emailValue, email: e.target.value });
        break;
      case 'dob':
        setDobValue({ ...dobValue, dob: e.target.value });
        break;
      case 'passport':
        setPassportValue({ ...passportValue, passport: e.target.value });
        break;
      case 'phoneNumber':
        setPhoneNumberValue({
          ...phoneNumberValue,
          phoneNumber: e.target.value,
        });
        checkDisabled();
        break;
      case 'phoneCountry':
        setPhoneCountryValue({
          ...phoneCountryValue,
          phoneCountry: e.target.value,
        });
        checkDisabled();
        break;
      case 'account':
        setAccountValue({ ...accountValue, account: e.target.value });
        break;
      default:
        break;
    }
  };

  const onChangeCheckbox = () => {
    toggleCheckBox((prev) => {
      // Get the updated State
      const newCheckboxState = !prev;
      checkDisabled(errors, newCheckboxState);
      return newCheckboxState;
    });
  };

  return (
    <>
      <section className="pad-2-lr text-justify">
        <Heading level={2} variant="sans-small-regular" className="text-align-center margin-0 margin-3-b">
          {renderHTML(benefitTitle)}
        </Heading>
        {safeDescription && <article className="margin-3-b">{safeDescription}</article>}
      </section>
      <Layout>
        {!isFetching && !error && (
          <CardMemberInfo {...data} languageData={languageData} />
        )}
        {shouldSuppressCheckbox || intl.formatMessage({
          id: 'hide-ui.tnc-checkbox',
          defaultMessage: '',
        }) === 'true'
          ? ''
          : (
            <section className="margin-t">
              <Checkbox
                id="enrollment-checkbox"
                data-testid="enrollment-checkbox"
                label={`${intl.formatMessage({ id: 'shared.terms-links.terms-and-conditions', defaultMessage: 'I understand and agree to the terms and conditions.‡' })}`}
                reactlytics={{
                  element: `${cardname}>>${benefitName}>>agree-to-terms`,
                }}
                onChange={onChangeCheckbox}
              />
            </section>
          )}
        {agreeError && !shouldSuppressCheckbox && (
          <ComponentLevelNotification className="pad-2-t">
            Please read and agree to the Terms & Conditions.
          </ComponentLevelNotification>
        )}
        {!name?.show && <div className="margin-t">{name?.label}</div>}
        {!address?.show && <div className="margin-t">{address?.label}</div>}
        {phone && !phone?.show && (
          <div className="margin-t">
            {phone && phone?.label ? phone?.label : null}
          </div>
        )}
        {!email?.show && <div className="margin-t">{email?.label}</div>}
        {!account?.show && (
          <div className="margin-t">{account?.memberAccount?.label}</div>
        )}
        {!dob?.show && <div className="margin-t">{dob?.label}</div>}
        {!passport?.show && <div className="margin-t">{passport?.label}</div>}
        {name?.show && (
          <>
            <FormField
              id="firstName"
              aria-labelledby="firstName"
              value={name?.firstName?.value}
              disabled={!!name?.firstName?.value}
              autofilled={fields?.firstName}
              field={name.firstName}
              onChange={(e) => onChangeInput(e, name.firstName)}
              success={isValid.firstName}
              inputWarning={errors.firstName} // Error message for firstName
            />
            <FormField
              id="lastName"
              aria-labelledby="lastName"
              value={name?.lastName?.value}
              disabled={!!name?.lastName?.value}
              autofilled={fields?.lastName}
              field={name.lastName}
              onChange={(e) => onChangeInput(e, name.lastName)}
              success={isValid.lastName}
              inputWarning={errors.lastName}
            />
            <FormField
              id="nameTitle"
              aria-labelledby="nameTitle"
              value={name?.nameTitle?.value}
              disabled={!!name?.nameTitle?.value}
              autofilled={fields?.nameTitle}
              field={name.nameTitle}
              onChange={(e) => onChangeInput(e, name.nameTitle)}
              success={isValid.nameTitle}
              inputWarning={errors.nameTitle}
            />
          </>
        )}
        {dob?.show && (
          <FormField
            id="dob"
            value={dob?.dateOfBirth?.value}
            disabled={!!dob?.dateOfBirth?.value}
            autofilled={fields?.dob}
            field={dob.dateOfBirth}
            onChange={(e) => onChangeInput(e, dob.dateOfBirth)}
            success={isValid.dob}
            inputWarning={errors.dob}
          />
        )}
        {passport?.show && (
          <FormField
            id="passport"
            value={passport?.fullName?.value}
            disabled={!!passport?.fullName?.value}
            autofilled={fields?.passport}
            field={passport.fullName}
            onChange={(e) => onChangeInput(e, passport.fullName)}
            success={isValid.passport}
            inputWarning={errors.passport}
          />
        )}
        {address?.show && (
          <>
            <FormField
              id="street1"
              value={address?.street1?.value}
              disabled={!!address?.street1?.value}
              autofilled={fields?.street1}
              field={address.street1}
              onChange={(e) => onChangeInput(e, address.street1)}
              success={isValid.street1}
              inputWarning={errors.street1}
            />
            <FormField
              id="street2"
              value={address?.street2?.value}
              disabled={!!address?.street2?.value}
              autofilled={fields?.street2}
              field={address.street2}
              onChange={(e) => onChangeInput(e, address.street2)}
              success={isValid.street2}
              inputWarning={errors.street2}
            />
            <FormField
              id="street3"
              value={address?.street3?.value}
              disabled={!!address?.street3?.value}
              autofilled={fields?.street3}
              field={address.street3}
              onChange={(e) => onChangeInput(e, address.street3)}
              success={isValid.street3}
              inputWarning={errors.street3}
            />
            <FormField
              id="city"
              value={address?.city?.value}
              disabled={!!address?.city?.value}
              autofilled={fields?.city}
              field={address.city}
              onChange={(e) => onChangeInput(e, address.city)}
              success={isValid.city}
              inputWarning={errors.city}
            />
            <FormField
              id="state"
              value={address?.state?.value}
              disabled={!!address?.state?.value}
              autofilled={fields?.state}
              field={address.state}
              onChange={(e) => onChangeInput(e, address.state)}
              success={isValid.state}
              inputWarning={errors.state}
            />
            <FormField
              id="postal"
              value={address?.postal?.value}
              disabled={!!address?.postal?.value}
              autofilled={fields?.postal}
              field={address.postal}
              onChange={(e) => onChangeInput(e, address.postal)}
              success={isValid.postal}
              inputWarning={errors.postal}
            />
            <FormField
              id="country"
              value={address?.country?.value}
              disabled={!!address?.country?.value}
              autofilled={fields?.country}
              field={address.country}
              onChange={(e) => onChangeInput(e, address.country)}
              success={isValid.country}
              inputWarning={errors.country}
            />
          </>
        )}
        {/* check if phone is in the validation object (as of now, only Accor has the phone field) */}
        {phone && phone?.show && (
          <>
            <FormField
              id="phoneNumber"
              value={phone?.phoneNumber?.value}
              disabled={!!phone?.phoneNumber?.value}
              autofilled={fields?.phoneNumber}
              field={phone.phoneNumber}
              onChange={(e) => onChangeInput(e, phone.phoneNumber)}
              success={isValid.phoneNumber}
              status={inputWarning ? 'error' : 'default'}
              inputWarning={errors.phoneNumber}
            />
            <div className="margin-t">
              <section className="pad-2-b">
                <SelectNative
                  id="phoneCountry"
                  label={phoneCountryLabel}
                  className="margin-2-b"
                  onChange={(e) => onChangeInput(e, phone.phoneCountry)}
                  data-testid="phonecountry-dropdown"
                  name="phoneCountry"
                  status={errors?.phoneCountry ? 'error' : 'default'}
                  statusMessage={errors.phoneCountry}
                >
                  {formattedSelections().map((item) => (
                    <SelectNativeOption key={item.value} value={item.value}>
                      {item.label}
                    </SelectNativeOption>
                  ))}
                </SelectNative>
              </section>
            </div>
          </>
        )}
        {email?.show && (
          <FormField
            id="email"
            value={email?.emailAddress?.value}
            disabled={!!email?.emailAddress?.value}
            autofilled={fields?.email}
            field={email.emailAddress}
            onChange={(e) => onChangeInput(e, email.emailAddress)}
            success={isValid.email}
            inputWarning={errors.email}
          />
        )}
        {account?.show && (
          <FormField
            id="account"
            data-testid="account"
            value={account?.memberAccount?.value}
            disabled={!!account?.memberAccount?.value}
            autofilled={fields?.account}
            field={account.memberAccount}
            onChange={(e) => onChangeInput(e, account.memberAccount)}
            success={isValid.account}
            status={inputWarning ? 'error' : 'default'}
            inputWarning={errors.account}
          />
        )}
        <ExtendReactlytics
          analytics={{
            event: {
              meta: {
                benefitname: `${parseEntities(benefitTitle)?.replace(/ /g, '-').toLowerCase()}`,
              },
            },
          }}
        >
          <Button
            id="enrollsubmit"
            className="flex flex-column flex-align-items-center margin-auto-lr margin-3-tb"
            reactlytics={{
              element: `cta>>enroll-submit>>${cardname?.replace(/ /g, '-').toLowerCase()}`,
              type: 'impression',
            }}
            onClick={submit}
            aria-disabled={isDisabled || isDisabledAfterSubmit}
            working={isLoading}
            aria-label={`${`${intl.formatMessage({ id: label })} ${benefitName}`}`}
            variant="primary"
          >
            {intl.formatMessage({
              id: `shared.terms-links.${label.replace(/ /g, '-').toLowerCase()}`,
              defaultMessage: label,
            })}
          </Button>
        </ExtendReactlytics>
      </Layout>
    </>
  );
}
